import { render, staticRenderFns } from "./PartFrom.vue?vue&type=template&id=3a8e678c&scoped=true&"
import script from "./PartFrom.vue?vue&type=script&lang=ts&"
export * from "./PartFrom.vue?vue&type=script&lang=ts&"
import style0 from "./PartFrom.vue?vue&type=style&index=0&id=3a8e678c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8e678c",
  null
  
)

export default component.exports